'use client'

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { FieldShell, premiumControlClass } from './field-shell'
import type { AnswerableFieldProps } from './types'

export function SelectField({ props, mode, value, onChange, error }: AnswerableFieldProps<'Select', string>) {
  const isPreview = mode === 'preview'
  const options = props.options ?? []
  return (
    <FieldShell
      mode={mode}
      htmlFor={props.id}
      label={props.label}
      required={props.required}
      helpText={props.helpText}
      error={error}
      conditional={Boolean(props.showIf)}
    >
      <Select
        value={isPreview ? undefined : typeof value === 'string' ? value : ''}
        onValueChange={isPreview ? undefined : v => onChange?.(v)}
        open={isPreview ? false : undefined}
      >
        <SelectTrigger id={props.id} className={premiumControlClass}>
          <SelectValue placeholder="Select…" />
        </SelectTrigger>
        <SelectContent>
          {options.map(opt => (
            <SelectItem key={opt} value={opt}>
              {opt}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FieldShell>
  )
}
